/*
 * @Author: benaozhi
 * @Date: 2020-07-19 19:37:31
 * @LastEditTime: 2022-10-19 22:31:42
 * @Description:
 */
import store from '@/render/store'
import { authorizationFormat } from '@/render/utils/helpers'

export const registerRequestInterceptors = axiosInstance => {
  // 这里注册你的请求拦截(成功操作)
  axiosInstance.interceptors.request.use(authorize, handleError)
}

/**
 * 请求拦截器
 * 前置操作：添加 token 到 header
 * @param {*} requestConfig
 */
function authorize(requestConfig) {
  // 从 store 中获取 token
  const token = store.getters['auth/token']
  if (token && !requestConfig.headers.token) {
    requestConfig.headers.token = authorizationFormat(token)
  }
  requestConfig = setUserType(requestConfig)
  return requestConfig
}
function setUserType (requestConfig) {
  const userType = store.getters['auth/userType']
  if (userType) {
    requestConfig.headers.userType = userType
    requestConfig.data = requestConfig.data ? requestConfig.data : ''
    if ((typeof requestConfig.data === 'string' && requestConfig.data.indexOf('userType') === -1)) {
      requestConfig.data += (requestConfig.data ? '&' : '') + `userType=${userType}`
    }
    if (typeof requestConfig.data === 'object') {
      Object.assign(requestConfig.data, {
        userType
      })
    }
  }
  return requestConfig
}
/**
 * 默认的请求拦截错误
 * @param {*} error
 */
function handleError(error) {
  const errorInfo = error.data.error ? error.data.error.message : error.data
  return Promise.reject(errorInfo)
}
